import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { percentGridLogic } from './percent_grid.logic';
import { PercentGridActivityView } from './PercentGridViews';

export const percentGridPlugin: ActivityPlugin<'percent_grid'> = {
  ...percentGridLogic,
  displayName: GAME_MODE_CATALOG.percent_grid.displayName,
  icon: GAME_MODE_CATALOG.percent_grid.icon,
  HostView: PercentGridActivityView,
  StudentView: PercentGridActivityView,
  ProjectorView: PercentGridActivityView,
};

export { demoPercentGridPayload } from './percent_grid.logic';
